import React, { useState } from "react";
import "./Contact_Form.css";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import Black_btn from "../../common-components/common-button/black-btn/Black_btn";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import Successfull_Lottie from "../../animtaion/Successfull_Lottie/Successfull_Lottie";
import { addContactus } from "../../../utils/apis/contact-us/ContactUs";

const Form_component = ({closeModal = () => {}}) => {
  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const [showModal, setShowModal] = useState(false);

  const navigate = useNavigate();

  const cityOptions = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];

  const [formSubmitted, setFormSubmitted] = useState(false);

  const onSubmit = async (data) => {
    console.log("testing");

    console.log("Form submitted with:", data);

    const htmlFormat = ` <div style="font-family: Arial, sans-serif; color: #333; padding: 20px; border: 1px solid #eee; border-radius: 8px; max-width: 600px; margin: auto;">
          <h2 style="color: #4CAF50; border-bottom: 2px solid #4CAF50; padding-bottom: 8px;">
            📩 New Contact Form Submission
          </h2>
          <p style="font-size: 16px; margin: 10px 0;">You’ve received a new enquiry from your website:</p>
          <table style="width: 100%; border-collapse: collapse; margin-top: 15px;">
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Name</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.product_name}</td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Name</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.name}</td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Email</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.email}</td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Contact No</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.contact_no}</td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">City</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.city}</td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Message</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${data.message}</td>
            </tr>
          </table>
        </div>`;

    try {
      const contactResponse = await addContactus(data);

      console.log("contactResponse", contactResponse);

      if (!contactResponse?.success) {
        console.error("Failed to save contact");
        return;
      }

      reset();

      setFormSubmitted(true);

      setTimeout(() => {
        navigate("/");
        closeModal()
      }, 3000);
    } catch (error) {
      console.error("Submission error:", error);
    }
  };

  return (
    <>
      <section className="Contact_Form innercontact">
        <div className="form_div">
          {!formSubmitted ? (
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Form.Group className="gray_input_group">
                <Form.Control
                  type="text"
                  placeholder="Enter Product name"
                  {...register("product_name", {
                    required: "Product name is required",
                  })}
                  className={classNames("", {
                    "is-valid": getValues("product_name"),
                  })}
                />
                {errors?.product_name && (
                  <span className="invalid-feedback d-block">
                    {errors.product_name.message}
                  </span>
                )}
              </Form.Group>

              <Form.Group className="gray_input_group">
                <Form.Control
                  type="text"
                  name="name"
                  placeholder="Enter Full Name*"
                  {...register("name", {
                    required: "Name is required",
                  })}
                  className={classNames("", {
                    "is-valid": getValues("name"),
                  })}
                />
                {errors?.name && (
                  <span className="invalid-feedback d-block">
                    {errors.name.message}
                  </span>
                )}
              </Form.Group>

              <Form.Group className="gray_input_group">
                <Form.Control
                  type="text"
                  placeholder="Enter Email*"
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Invalid email address",
                    },
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.email,
                    "is-valid": getValues("email"),
                  })}
                />
                {errors?.email && (
                  <span className="invalid-feedback d-block">
                    {errors.email.message}
                  </span>
                )}
              </Form.Group>

              <Form.Group className="gray_input_group">
                <Controller
                  name="contact_no"
                  control={control}
                  rules={{
                    required: "Contact number is required",
                    validate: (value) =>
                      value.replace(/\D/g, "").length >= 12 ||
                      "Number should be at least 10 digits",
                  }}
                  render={({ field }) => (
                    <PhoneInput
                      {...field}
                      country={"in"}
                      onChange={(value) => field.onChange(value)}
                      inputClass={classNames("", {
                        "is-invalid": errors?.contact_no,
                        "is-valid": getValues("contact_no"),
                      })}
                    />
                  )}
                />
                {errors?.contact_no && (
                  <span className="invalid-feedback d-block">
                    {errors.contact_no.message}
                  </span>
                )}
              </Form.Group>

              <Form.Group className="gray_input_group">
                <Form.Control
                  type="text"
                  name="city"
                  placeholder="Enter City"
                  {...register("city", {
                    required: "City is required",

                    maxLength: {
                      value: 100,
                      message: "City cannot exceed 100 characters"
                    }
                  })}
                  className={classNames("", {
                    "is-valid": getValues("city"),
                  })}
                />
                {errors?.city && (
                  <span className="invalid-feedback d-block">
                    {errors.city.message}
                  </span>
                )}
              </Form.Group>

              <Form.Group className="gray_input_group">
                <Form.Control
                  as={"textarea"}
                  type="text"
                  name="message"
                  placeholder="Write your message here"
                  {...register("message", {
                    required: "Message is required",
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.message,
                    "is-valid": getValues("message"),
                  })}
                />
                {errors?.message && (
                  <span className="invalid-feedback d-block">
                    {errors.message.message}
                  </span>
                )}
              </Form.Group>

              <div className="send_btn_div">
                <Black_btn btn_name="Submit" type="submit" />
              </div>
            </Form>
          ) : (
            <div className="success_div">
              <Successfull_Lottie successText="Message Sent Successfully" />
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Form_component;
